import Vue from 'vue';

Vue.directive('error', {
  bind (el, binding, vnode) {
    vnode.componentInstance.$on('error', (e) => {
      vnode.context[binding.expression] = !!e;
    })
  }
});



// WEBPACK FOOTER //
// ./src/directives/error.directive.js